import React from 'react';
import { SonarRecord } from '@ui/records';
export const PardotPicklistValue = ({ picklistValue }) => React.createElement(SonarRecord, { name: picklistValue.displayName, secondaryInfo: picklistValue.internalName, sonarObjectId: null });
